module.exports = __webpack_public_path__ + "img/guernsey.3f7d88a0.svg";